var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  width: _vm.size,
  height: _vm.size,
  borderRadius: _vm.size,
  background: _vm.background,
})})}
var staticRenderFns = []

export { render, staticRenderFns }